// Đầu trang "Xu & Hạng": tiêu đề, mô tả 1 dòng, huy hiệu trạng thái chương trình và ngày ra mắt hạng.
import { Tag } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoins } from "@fortawesome/free-solid-svg-icons";
import { fmtVnDateTime } from "./xu-format-helpers";

/** Trạng thái nói bằng lời: TẮT / Beta N người / Đang mở cho mọi người. */
export function programStatus(flags) {
    if (!flags) return { color: "default", text: "Đang tải…" };
    if (!flags.global) return { color: "red", text: "ĐANG TẮT" };
    if (!flags.visible) return { color: "orange", text: `Beta ${flags.betaUserIds.length} người` };
    return { color: "green", text: "Đang mở cho mọi người" };
}

export function rankLaunchText(rankLaunchAt) {
    if (!rankLaunchAt) return "Hạng: chưa ra mắt";
    const launched = Date.now() / 1000 >= rankLaunchAt;
    return `Hạng ${launched ? "ra mắt từ" : "sẽ ra mắt"} ${fmtVnDateTime(rankLaunchAt)}`;
}

export default function XuProgramHeader({ flags, rankLaunchAt }) {
    const st = programStatus(flags);
    return (
        <div className="flex flex-wrap items-start justify-between gap-3">
            <div className="flex items-start gap-3">
                <div className="bg-amber-50 rounded-xl w-11 h-11 flex items-center justify-center shrink-0">
                    <FontAwesomeIcon icon={faCoins} className="text-amber-500" />
                </div>
                <div>
                    <h1 className="text-xl font-semibold m-0">Xu &amp; Hạng</h1>
                    <p className="text-xs text-gray-500 m-0">Điểm danh nhận Xu, nhiệm vụ mỗi ngày và hạng thành viên: cài đặt, theo dõi người tham gia và chi phí.</p>
                </div>
            </div>
            <div className="flex flex-wrap items-center gap-2">
                <Tag color={st.color} className="!m-0 !text-sm !px-3 !py-0.5">{st.text}</Tag>
                {flags && <Tag className="!m-0">{rankLaunchText(rankLaunchAt)}</Tag>}
            </div>
        </div>
    );
}
